import React, { useState, useEffect } from 'react';
import { logo } from '../../../assets';
import { useNavigate } from 'react-router-dom';
import axios from '../../../library/axios';
import { getModule, setHrefWithSlugHook, useNavigateWithSlugHook, } from "../../../../src/config/routes/guards/slug";
import { getSlug, } from "../../../../src/config/routes/guards/slug";

const NavbarComp = () => {
  const [namaLengkap, setnamaLengkap] = useState('');
  const [currentUrl, setCurrentUrl] = useState('');
  const [menuGeneral, setmenuGeneral] = useState([]);
  const [menuMaster, setmenuMaster] = useState([]);
  const [menuMasterRisk, setmenuMasterRisk] = useState([]);
  const [menuTransactions, setmenuTransactions] = useState([]);

  const navigate = useNavigateWithSlugHook();
  const logout = () => {
    setCurrentUrl("/logout");
    localStorage.removeItem(`token${getSlug() ? '-' + getSlug() : ''}`);
    setHrefWithSlugHook('/login');
  };
  const handleChangePage = (path) => {
    setCurrentUrl(path);
    navigate(path);
  };

  const fetchData = async () => {
    try {
      const options = {
        url: `/users/detailUser`,
        method: 'GET',
        headers: {
          'Access-Control-Allow-Origin': '*',
          Authorization: `Bearer ${localStorage.getItem(`token${getSlug() ? '-' + getSlug() : ''}`)}`,
        },
      };
      const { data } = await axios(options);
      // console.log(data?.data);
      setnamaLengkap(data?.data?.namaLengkap);
      setmenuGeneral([]);
      setmenuMaster([]);
      setmenuMasterRisk([]);
      setmenuTransactions([]);
      for (
        let i = 0;
        i <
        data?.data?.mapping_user_groups[0]?.group?.mapping_module_groups.length;
        i++
      ) {
        if (
          data?.data?.mapping_user_groups[0]?.group?.mapping_module_groups[i]
            ?.module?.pathModule === '/accreditation' ||
          data?.data?.mapping_user_groups[0]?.group?.mapping_module_groups[i]
            ?.module?.pathModule === '/documents'
        ) {
          setmenuTransactions((menuTransactions) => [
            ...menuTransactions,
            {
              label:
                data.data.mapping_user_groups[0].group.mapping_module_groups[i]
                  .module.namaModule,
              path: data.data.mapping_user_groups[0].group
                .mapping_module_groups[i].module.pathModule,
            },
          ]);
        } else if (
          // data.data.mapping_user_groups[i].module.pathModule === '/logout' ||
          // data.data.mapping_user_groups[i].module.pathModule === '/dashboard-external' ||
          data?.data?.mapping_user_groups[0]?.group?.mapping_module_groups[i]
            ?.module?.pathModule === '/dashboard-pokja' ||
          data?.data?.mapping_user_groups[0]?.group?.mapping_module_groups[i]
            ?.module?.pathModule === '/dashboard-internal'
        ) {
          setmenuGeneral((menuGeneral) => [
            ...menuGeneral,
            {
              label:
                data.data.mapping_user_groups[0].group.mapping_module_groups[i]
                  .module.namaModule,
              path: data.data.mapping_user_groups[0].group
                .mapping_module_groups[i].module.pathModule,
            },
          ]);
        } else if (
          data?.data?.mapping_user_groups[0]?.group?.mapping_module_groups[i]
            ?.module?.pathModule === '/users' ||
          data?.data?.mapping_user_groups[0]?.group?.mapping_module_groups[i]
            ?.module?.pathModule === '/profile' ||
          data?.data?.mapping_user_groups[0]?.group?.mapping_module_groups[i]
            ?.module?.pathModule === '/standards-accreditation' ||
          data?.data?.mapping_user_groups[0]?.group?.mapping_module_groups[i]
            ?.module?.pathModule === '/chapters-accreditation' ||
          data?.data?.mapping_user_groups[0]?.group?.mapping_module_groups[i]
            ?.module?.pathModule === '/elements-accreditation' ||
          data?.data?.mapping_user_groups[0]?.group?.mapping_module_groups[i]
            ?.module?.pathModule === '/variables-accreditation' ||
          data?.data?.mapping_user_groups[0]?.group?.mapping_module_groups[i]
            ?.module?.pathModule === '/risk-divisions'
        ) {
          setmenuMaster((menuMaster) => [
            ...menuMaster,
            {
              label:
                data?.data?.mapping_user_groups[0]?.group
                  ?.mapping_module_groups[i]?.module?.namaModule,
              path: data?.data?.mapping_user_groups[0]?.group
                ?.mapping_module_groups[i]?.module?.pathModule,
            },
          ]);
        } else if (
          data?.data?.mapping_user_groups[0]?.group?.mapping_module_groups[i]
            ?.module?.pathModule === '/risk-activity-targets' ||
          data?.data?.mapping_user_groups[0]?.group?.mapping_module_groups[i]
            ?.module?.pathModule === '/risk-heatmap'
        ) {
          setmenuMasterRisk((menuMasterRisk) => [
            ...menuMasterRisk,
            {
              label:
                data?.data?.mapping_user_groups[0]?.group
                  ?.mapping_module_groups[i]?.module?.namaModule,
              path: data?.data?.mapping_user_groups[0]?.group
                ?.mapping_module_groups[i]?.module?.pathModule,
            },
          ]);
        }
      }
      // console.log(data)
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  // console.log(menuMasterRisk);

  return (
    <>
      {/*begin::Aside*/}
      <div
        style={{ background: 'linear-gradient(#3498DB, #5DADE2)' }}
        id="kt_aside"
        className="aside aside-hoverable"
        data-kt-drawer="true"
        data-kt-drawer-name="aside"
        data-kt-drawer-activate='{"default": true, "lg": false}'
        data-kt-drawer-overlay="true"
        data-kt-drawer-width='{"default":"200px","300px":"250px"}'
        data-kt-drawer-direction="start"
        data-kt-drawer-toggle="#kt_aside_mobile_toggle"
      >
        {/* ================= BRAND ================= */}
        <div className="aside-logo flex-column-auto aside-logo-custom" id="kt_aside_logo">
          <a href="#">
            <img alt="Logo" src={logo} className="w-200px h-50px" />
          </a>

          {/* Toggle */}
          <div
            id="kt_aside_toggle"
            data-kt-toggle="true"
            data-kt-toggle-state="active"
            data-kt-toggle-target="body"
            data-kt-toggle-name="aside-minimize"
            className="btn btn-icon w-30px h-30px"
          >
            <span className="svg-icon svg-icon-1 rotate-180">
              <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} viewBox="0 0 24 24" fill="none">
                <path
                  opacity="0.5"
                  d="M14.2657 11.4343L18.45 7.25C18.8642 6.83579 18.8642 6.16421 18.45 5.75C18.0358 5.33579 17.3642 5.33579 16.95 5.75L11.4071 11.2929C11.0166 11.6834 11.0166 12.3166 11.4071 12.7071L16.95 18.25C17.3642 18.6642 18.0358 18.6642 18.45 18.25C18.8642 17.8358 18.8642 17.1642 18.45 16.75L14.2657 12.5657C13.9533 12.2533 13.9533 11.7467 14.2657 11.4343Z"
                  fill="currentColor"
                />
                <path
                  d="M8.2657 11.4343L12.45 7.25C12.8642 6.83579 12.8642 6.16421 12.45 5.75C12.0358 5.33579 11.3642 5.33579 10.95 5.75L5.40712 11.2929C5.01659 11.6834 5.01659 12.3166 5.40712 12.7071L10.95 18.25C11.3642 18.6642 12.0358 18.6642 12.45 18.25C12.8642 18.6642 12.8642 17.1642 12.45 16.75L8.2657 12.5657C7.95328 12.2533 7.95328 11.7467 8.2657 11.4343Z"
                  fill="currentColor"
                />
              </svg>
            </span>
          </div>
        </div>

        {/* ================= MENU ================= */}
        <div className="aside-menu flex-column-fluid">
          <div
            className="hover-scroll-overlay-y my-5 my-lg-5"
            id="kt_aside_menu_wrapper"
            data-kt-scroll="true"
            data-kt-scroll-activate="{default: false, lg: true}"
            data-kt-scroll-height="auto"
            data-kt-scroll-dependencies="#kt_aside_logo, #kt_aside_footer"
            data-kt-scroll-wrappers="#kt_aside_menu"
            data-kt-scroll-offset={0}
          >
            <div
              className="menu menu-column menu-state-title-primary menu-state-icon-primary menu-state-bullet-primary"
              id="kt_aside_menu"
              data-kt-menu="true"
            >

              {/* SECTION TITLE */}
              {
                menuGeneral.length > 0 ?
                  <>
                    <div className="menu-item">
                      <div className="menu-content pb-2">
                        <span className="menu-section text-dark text-uppercase fs-7 ls-1">
                          General
                        </span>
                      </div>
                    </div>
                  </>
                  :
                  ""
              }
              {/* MENU ITEM */}
              {menuGeneral.map((row, i) => (
                <div className="menu-item" key={i}>
                  <a
                    className="menu-link"
                    onClick={() => handleChangePage(`${row.path}`)}
                    style={{
                      color: "#fff",
                      transition: "0.2s",
                    }}
                  >
                    <span className="svg-icon svg-icon-2" style={{ color: "#fff" }}>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width={24}
                        height={24}
                        viewBox="0 0 24 24"
                        fill="none"
                      >
                        <path
                          d="M9 6L15 12L9 18"
                          stroke="currentColor"
                          strokeWidth={2}
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </svg>
                    </span>
                    <span className="menu-title">{row.label}</span>
                  </a>
                </div>
              ))}

              {/* SECTION TITLE */}
              {
                menuMaster.length > 0 ?
                  <>
                    <div className="menu-item">
                      <div className="menu-content pb-2">
                        <span className="menu-section text-dark text-uppercase fs-7 ls-1">
                          Data Master
                        </span>
                      </div>
                    </div>
                  </>
                  :
                  ""
              }
              {/* MENU ITEM */}
              {menuMaster.map((row, i) => (
                <div className="menu-item" key={i}>
                  <a
                    className="menu-link"
                    onClick={() => handleChangePage(`${row.path}`)}
                    style={{
                      color: "#fff",
                      transition: "0.2s",
                    }}
                  >
                    <span className="svg-icon svg-icon-2" style={{ color: "#fff" }}>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width={24}
                        height={24}
                        viewBox="0 0 24 24"
                        fill="none"
                      >
                        <path
                          d="M9 6L15 12L9 18"
                          stroke="currentColor"
                          strokeWidth={2}
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </svg>
                    </span>
                    <span className="menu-title">{row.label}</span>
                  </a>
                </div>
              ))}

              {/* SECTION TITLE */}
              {
                menuTransactions.length > 0 ?
                  <>
                    <div className="menu-item">
                      <div className="menu-content pb-2">
                        <span className="menu-section text-dark text-uppercase fs-7 ls-1">
                          Data Transaksi
                        </span>
                      </div>
                    </div>
                  </>
                  :
                  ""
              }
              {/* MENU ITEM */}
              {menuTransactions.map((row, i) => (
                <div className="menu-item" key={i}>
                  <a
                    className="menu-link"
                    onClick={() => handleChangePage(`${row.path}`)}
                    style={{
                      color: "#fff",
                      transition: "0.2s",
                    }}
                  >
                    <span className="svg-icon svg-icon-2" style={{ color: "#fff" }}>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width={24}
                        height={24}
                        viewBox="0 0 24 24"
                        fill="none"
                      >
                        <path
                          d="M9 6L15 12L9 18"
                          stroke="currentColor"
                          strokeWidth={2}
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </svg>
                    </span>
                    <span className="menu-title">{row.label}</span>
                  </a>
                </div>
              ))}

              {/* SECTION TITLE */}
              {
                menuMasterRisk.length > 0 ?
                  <>
                    <div className="menu-item">
                      <div className="menu-content pb-2">
                        <span className="menu-section text-dark text-uppercase fs-7 ls-1">
                          Risk Management
                        </span>
                      </div>
                    </div>
                  </>
                  :
                  ""
              }
              {/* MENU ITEM */}
              {menuMasterRisk.map((row, i) => (
                <div className="menu-item" key={i}>
                  <a
                    className="menu-link"
                    onClick={() => handleChangePage(`${row.path}`)}
                    style={{
                      color: "#fff",
                      transition: "0.2s",
                    }}
                  >
                    <span className="svg-icon svg-icon-2" style={{ color: "#fff" }}>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width={24}
                        height={24}
                        viewBox="0 0 24 24"
                        fill="none"
                      >
                        <path
                          d="M9 6L15 12L9 18"
                          stroke="currentColor"
                          strokeWidth={2}
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </svg>
                    </span>
                    <span className="menu-title">{row.label}</span>
                  </a>
                </div>
              ))}

              {/* SECTION TITLE */}
              {/* Selalu tampil untuk semua peran, tidak bergantung pada mapping module. */}
              <div className="menu-item">
                <div className="menu-content pb-2">
                  <span className="menu-section text-dark text-uppercase fs-7 ls-1">
                    Bantuan
                  </span>
                </div>
              </div>
              {/* MENU ITEM */}
              <div className="menu-item">
                <a
                  className="menu-link"
                  onClick={() => handleChangePage('/panduan')}
                  style={{
                    color: "#fff",
                    transition: "0.2s",
                  }}
                >
                  <span className="svg-icon svg-icon-2" style={{ color: "#fff" }}>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width={24}
                      height={24}
                      viewBox="0 0 24 24"
                      fill="none"
                    >
                      <path
                        d="M9 6L15 12L9 18"
                        stroke="currentColor"
                        strokeWidth={2}
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                  </span>
                  <span className="menu-title">Panduan Pengguna</span>
                </a>
              </div>

            </div>
          </div>
        </div>

        {/* ================= FOOTER ================= */}
        <div className="aside-footer flex-column-auto pt-5 pb-7 px-5" id="kt_aside_footer">
          <a
            href="https://lam-kprs.id/"
            className="btn w-100"
            style={{
              backgroundColor: "rgba(9, 29, 142, 0.49)",
              color: "#fff",
              border: "1px solid rgba(9, 29, 142, 0.49)"
            }}
            title='Made with love by TIKOM'
          >
            <span className="btn-label">2026© | LAM-KPRS</span>
          </a>
        </div>
      </div>
      {/*end::Aside*/}
    </>
  );
};

export default NavbarComp;
